import React from "react";

const Preloader = () => {
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",        // full page center
    width: "100%",
  };

  const innerStyle = {
    display: "inline-grid",
    placeItems: "center",
    width: "82px",          // 10px bigger
    height: "65px",         // ~82 * 0.8
    position: "relative",
  };

  const ringStyle = {
    position: "absolute",
    inset: "-12px",
    borderRadius: "16px",
    boxShadow: "0 0 0 6px rgba(1,154,162,0.18), 0 10px 30px rgba(1,154,162,0.12)",
    filter: "blur(0.2px)",
  };

  const svgStyle = {
    width: "100%",
    height: "100%",
    color: "#019aa2",       // teal color
  };

  const ekgStyle = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 6,         // thicker (was 4)
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "420 480",
    strokeDashoffset: 480,
    animation: "ekg-flow 1.6s ease-in-out infinite",
  };

  const crossStyle = {
    fill: "#019aa2",
    opacity: 0.95,
    transformOrigin: "center",
    animation: "cross-pulse 1.6s ease-in-out infinite",
    filter: "drop-shadow(0 2px 6px rgba(1,154,162,0.2))",
  };

  return (
    <div style={containerStyle}>
      <div style={innerStyle}>
        <div style={ringStyle} />
        <svg
          style={svgStyle}
          viewBox="0 0 240 120"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            style={ekgStyle}
            d="M0,60 L40,60
               60,60 70,35 85,85 100,45 110,60
               150,60 170,60 180,35 195,85 210,45 220,60 240,60"
          />
          <g style={crossStyle} transform="translate(175,15)">
            <rect x="20" y="0" width="20" height="20" rx="3" />
            <rect x="0" y="20" width="20" height="20" rx="3" />
            <rect x="20" y="20" width="20" height="20" rx="3" />
            <rect x="40" y="20" width="20" height="20" rx="3" />
            <rect x="20" y="40" width="20" height="20" rx="3" />
          </g>
        </svg>

        {/* Inline keyframes */}
        <style>
          {`
            @keyframes ekg-flow {
              0%   { stroke-dashoffset: 480; opacity: 0.8; }
              40%  { opacity: 1; }
              60%  { opacity: 1; }
              100% { stroke-dashoffset: 0; opacity: 0.85; }
            }
            @keyframes cross-pulse {
              0%   { transform: translate(175px,15px) scale(0.96); opacity: 0.9; }
              50%  { transform: translate(175px,15px) scale(1.04); opacity: 1; }
              100% { transform: translate(175px,15px) scale(0.96); opacity: 0.9; }
            }
          `}
        </style>
      </div>
    </div>
  );
};

export default Preloader;
